var _defs, _rect, _circle, _circle2, _circle3, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg503(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}.b{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.55,
    y: -0.27,
    width: 800,
    height: 800
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 400,
    cy: 400,
    r: 450
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 400,
    cy: 400,
    r: 300
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 400,
    cy: 399.7,
    r: 150
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 352.82,
    y: 367.85,
    width: 12,
    height: 42,
    transform: "translate(-169.86 367.61) rotate(-45)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 388.88,
    y: 331.79,
    width: 12,
    height: 42,
    transform: "translate(-133.8 382.55) rotate(-45)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 364.08,
    y: 383.55,
    width: 63,
    height: 12,
    transform: "translate(-159.59 393.81) rotate(-45)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 421.74,
    y: 381.71,
    width: 12,
    height: 80,
    transform: "translate(-172.91 425.98) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg503);
export default __webpack_public_path__ + "static/media/503.21a5647db62f7e69eb4b61394392f1ad.svg";
export { ForwardRef as ReactComponent };